// import monitorReportList from '../components/monitorReport/monitorReportList.vue'

export default [
    { 
        path: 'monitorReport/monitorReportList', 
        component: resolve => require(['@/components/monitorReport/monitorReportList'],resolve),
        name:'monitorReportList',
        meta:{
            id:'852',
            node:'monitorReport',
            url:'monitorReportList',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/monitorReport.js